export const GET_APP_NOTICES = 'GET_APP_NOTICES';//获取应用通知

export const GET_APP_NOTICE = 'GET_APP_NOTICE'//获取应用通知信息
export const SEND_APP_NOTICES = 'SEND_APP_NOTICES'//获取应用通知信息